'use client'

// Supabase is deactivated on the public site; no active cohort data is loaded.
export function useActiveCohort() {
  return { cohort: null, isLoading: false }
}
